import {FormControl} from '@angular/forms';

export class branches_settings{
  id: string;
  name: string;
  branch: string;
  branch_id: string;
  supervisors: string;
  branch_users: string;
  last_update_user:string;
  last_update_ip:string;
  on_behalf_of:string;
  last_on_behalf_of:string;
  showDeletedOnly: boolean;
  constructor() {
  }
}


// WEBPACK FOOTER //
// ./src/app/views/setting/branches_settings/branches_settings.ts